import { render, staticRenderFns } from "./FormStepIndicator.vue?vue&type=template&id=bd2dcef6&scoped=true&"
import script from "./FormStepIndicator.vue?vue&type=script&lang=js&"
export * from "./FormStepIndicator.vue?vue&type=script&lang=js&"
import style0 from "./FormStepIndicator.vue?vue&type=style&index=0&id=bd2dcef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2dcef6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd2dcef6')) {
      api.createRecord('bd2dcef6', component.options)
    } else {
      api.reload('bd2dcef6', component.options)
    }
    module.hot.accept("./FormStepIndicator.vue?vue&type=template&id=bd2dcef6&scoped=true&", function () {
      api.rerender('bd2dcef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/FormStepIndicator.vue"
export default component.exports